import WizardLayout from './WizardLayout';

export default WizardLayout;
